@if (indicator) {
<indicator-chip
  [label]="indicator?.label"
  [state]="indicator?.state"
  [type]="indicator?.type"
  [expiryDate]="indicator?.expiryDate"
  [color]="indicator?.color"
  [tooltip]="indicator?.tooltip">
</indicator-chip>
}
